module.exports = __webpack_public_path__ + "static/media/truck-avatar.6af8e9f5.svg";